import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  CLOSE_COIN_PLAN_DIALOG,
  CREATE_NEW_COIN_PLAN,
  DELETE_COIN_PLAN,
  DIAS_APP_PURCHASE,
  EDIT_COIN_PLAN,
  GET_COIN_PLAN,
  GET_COIN_PLAN_HISTORY,
  GET_PURCHASE_TRANSACTIONS,
} from "./types";

export const getPurchaseTransactions = (page, limit) => (dispatch) => {
  axios
    .get(`/purchaseTransaction?page=${page}&limit=${limit}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: GET_PURCHASE_TRANSACTIONS,
          payload: { data: res.data.data, total: res.data.total },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const getCoinPlan = () => (dispatch) => {
  axios
    .get(`diamondPlan?platform=android`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_COIN_PLAN, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const createNewCoinPlan = (data) => (dispatch) => {
  axios
    .post(`diamondPlan`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Plan created successfully!");
        dispatch({ type: CLOSE_COIN_PLAN_DIALOG });
        dispatch({ type: CREATE_NEW_COIN_PLAN, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const editCoinPlan = (coinPlanId, data) => (dispatch) => {
  axios
    .patch(`diamondPlan/${coinPlanId}`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Plan updated successfully!");
        dispatch({ type: CLOSE_COIN_PLAN_DIALOG });
        dispatch({
          type: EDIT_COIN_PLAN,
          payload: { data: res.data.data, id: coinPlanId },
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
export const deleteCoinPlan = (coinPlanId) => (dispatch) => {
  axios
    .delete(`diamondPlan/${coinPlanId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: DELETE_COIN_PLAN, payload: coinPlanId });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const coinPlanHistory =
  (id, start, limit, sDate, eDate) => (dispatch) => {
    const url =
      id !== null
        ? `diamondPlan/history?userId=${id}&start=${start}&limit=${limit}&startDate=${sDate}&endDate=${eDate}`
        : `diamondPlan/history?start=${start}&limit=${limit}&startDate=${sDate}&endDate=${eDate}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: GET_COIN_PLAN_HISTORY,
            payload: { history: res.data.data.history, total: res.data.data.total },
          });
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((error) => console.log(error));
  };


export const diasAppPurchase = (data) => (dispatch) => {
  console.log("diasAppPurchase data:", data);
  axios
    .post(`coinPlan/purchase/googlePlay`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Dias App Purchase recorded successfully!");
        dispatch({ type: DIAS_APP_PURCHASE });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};
